import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";
import { Reveal } from "../components/Reveal";
import Newsletter from "../components/Newsletter";
import { useSEO } from "../lib/useSEO";

export default function ReflexaoDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useSEO({ title: post?.title, description: post?.excerpt, image: post?.cover_url });

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    api.get(`/posts/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound)
    return (
      <div className="mx-auto max-w-3xl px-6 py-40 text-center" data-testid="post-not-found">
        <h1 className="font-serif text-4xl text-zinc-100">Reflexão não encontrada</h1>
        <Link to="/reflexoes" className="btn-gold mt-10">Voltar às reflexões</Link>
      </div>
    );

  if (!post)
    return (
      <div className="mx-auto max-w-3xl px-6 py-40" data-testid="post-loading">
        <p className="font-serif text-zinc-500">Carregando…</p>
      </div>
    );

  return (
    <article data-testid="post-detail-page">
      <div className="mx-auto max-w-4xl px-6 pt-20 lg:pt-32">
        <Reveal>
          <Link to="/reflexoes" className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 transition-colors hover:text-gold" data-testid="back-to-posts-link">
            <ArrowLeft size={14} /> Reflexões
          </Link>
          <h1 className="mt-10 font-serif text-4xl leading-tight text-zinc-100 sm:text-5xl lg:text-6xl">{post.title}</h1>
          <p className="mt-6 max-w-2xl font-serif text-lg italic text-gold/80">{post.excerpt}</p>
        </Reveal>
      </div>
      {post.cover_url && (
        <Reveal className="mx-auto mt-14 max-w-5xl px-6">
          <div className="hairline-frame relative aspect-[21/9] overflow-hidden border border-gold/20">
            <img src={post.cover_url} alt={post.title} className="h-full w-full object-cover" />
          </div>
        </Reveal>
      )}
      <Reveal className="mx-auto max-w-3xl px-6 py-16 lg:py-24">
        <div className="space-y-8" data-testid="post-content">
          {post.content.split(/\n+/).filter(Boolean).map((paragraph, i) => (
            <p key={i} className="text-base leading-loose text-zinc-300">{paragraph}</p>
          ))}
        </div>
        <div className="mt-16 border-t border-gold/15 pt-10">
          <p className="font-serif text-2xl text-gold">✦</p>
        </div>
      </Reveal>
      <Newsletter />
    </article>
  );
}
